var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-test-id": "svg-wrapper",
    width: 18,
    height: 18,
    viewBox: "0 0 42 42",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57.5 23.8c0-1.9-1.4-3.5-3.3-3.7s-3.7 1-4.1 2.9 0.6 3.7 2.4 4.4c-1.3 3.3-2.2 6.7-2.5 10.2h-2.5v-5c0-8.3-6.7-15-15-15s-15 6.7-15 15v22.4c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h3.8c2.1 0 3.7-1.7 3.7-3.7v-5c0-1.5-0.9-2.9-2.4-3.5 0.1-3.5 0.6-6.9 1.4-10.3 2-0.1 3.5-1.8 3.5-3.7zm-25-3.8c6.9 0 12.5 5.6 12.5 12.5v17.5h-25v-17.5c0-6.9 5.6-12.5 12.5-12.5z",
    transform: "translate(-16 -16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.5 22.5c-5.5 0-10 4.5-10 10h20c0-5.5-4.5-10-10-10z",
    transform: "translate(-16 -16)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 35,
    width: 20,
    height: 12.5,
    transform: "translate(-16 -16)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlot);
export default __webpack_public_path__ + "static/media/slot.0c7686edd2123a7209e33d7c489f5b22.svg";
export { ForwardRef as ReactComponent };